import { render, staticRenderFns } from "./StartRoundView.vue?vue&type=template&id=620d0b98&scoped=true"
import script from "./StartRoundView.vue?vue&type=script&lang=js"
export * from "./StartRoundView.vue?vue&type=script&lang=js"
import style0 from "./StartRoundView.vue?vue&type=style&index=0&id=620d0b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d0b98",
  null
  
)

export default component.exports